import { weekDayShortLabels } from 'components/constants';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styled, { css } from 'styled-components';

export interface IWeekDaySelect {
  onClick: (index: number) => void;
  hasError?: boolean;
  selected: number | null;
  className?: string;
}

export const WeekDaySelect = ({
  hasError,
  className,
  selected,
  onClick,
}: IWeekDaySelect) => {
  const { t } = useTranslation();
  return (
    <Container className={className} hasError={hasError || false}>
      {weekDayShortLabels(t).map((day, index) => (
        <DayWrapper
          selected={index === selected}
          // Индекс — стабильный ключ: подписи меняются вместе с языком.
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          onClick={() => onClick(index)}
        >
          {day.toUpperCase()}
        </DayWrapper>
      ))}
    </Container>
  );
};

const Container = styled.div<{ hasError: boolean }>`
  display: flex;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  height: 48px;
  width: 350px;

  ${({ hasError }) => {
    if (hasError) {
      return css`
        border-color: var(--k-border-f44336);
      `;
    }

    return css`
      border-color: var(--k-border-ebeff2);
    `;
  }}
`;

const DayWrapper = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--k-border-ebeff2);
  width: 50px;
  background-color: ${({ selected }) =>
    selected ? 'var(--k-bg-0d53fc)' : 'var(--k-bg-ffffff)'};
  color: ${({ selected }) =>
    selected ? 'var(--k-fg-ffffff)' : 'var(--k-fg-263446)'};
`;
